module.exports = __webpack_public_path__ + "img/banner.4c7f18dc.png";